import styled, { css } from 'styled-components';
import backgroundImage from '@/media/MultiAgentsHome/background-image.png';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 40px;
    padding: 24px;
    border-radius: 16px;
    background-image: url(${backgroundImage});
    background-size: cover;
    background-position: center 70%;
    background-repeat: no-repeat;
    height: 332px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      align-items: center;
      gap: 24px;
      height: auto;
      padding: 24px 16px;
    }
  `}
`;

export const PostImageWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
    overflow: hidden;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
      max-width: 280px;
    }
  `}
`;

export const PostImage = styled.img`
  ${({ theme }) => css`
    width: 176px;
    height: 222px;
    object-fit: cover;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
      height: auto;
      aspect-ratio: 176 / 222;
    }
  `}
`;

export const PostMetrics = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 16px 4px;
`;

export const MetricItem = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 4px;
    color: #5a5f66;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const MetricIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5a5f66;
`;

export const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 40px;
    max-width: 668px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      gap: 24px;
      width: 100%;
    }
  `}
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 16px;
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.title};
    margin: 0 0 8px 0;
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowLight};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0;
  `}
`;

export const ButtonWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-start;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;

      button {
        width: 100%;
      }
    }
  `}
`;
